import styled from 'styled-components/macro';
export const SvgStyled = styled.svg `
  &:hover {
    cursor: pointer;
  }

  & > g > circle {
    animation: all 2s linear infinite;
  }
`;
